// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import Header from '../../layouts/MainLayout/Header';
import TitleSectionBackground from './assets/title-background.svg'
import LabSectionBackground from './assets/lab-background.svg'
import MultiCloudSectionBackground from './assets/multi-cloud-background.png'
import MultiCloudSectionLineArt from './assets/multi-cloud-line-art.svg'
import MultiCloudSectionIcon from './assets/multi-cloud-icon.svg'
import DomainSectionBackground from './assets/domain-section.svg'
import MultiLanguageSectionBackground from './assets/multi-language-background.svg'
import LastSectionBackground from './assets/last-section-background.png'
import EnglishDomainsImage from './assets/domains-en.svg'
import ChineseDomainsImage from './assets/domains-zh.svg'
import LabImage from '../../assets/images/pic_lab.png';
import TitleIcon from './assets/title-icon.svg';
import GlobeImg from './assets/globe.svg'
import LogoIcon from '../../assets/images/logo.svg';
import ReactPlayer from 'react-player'
import Button from '../../components/Button';
import { Link, RouteProps } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import LanguageContext from '../../contexts/LanguageContext';

const STitleSection = {
  Container: styled.div`
    margin-top: 70px;
    height: 100%;
    display: flex;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${TitleSectionBackground});
    overflow: auto;
  `,
  LeftContainer: styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  LeftWrapper: styled.div`
    display: flex;
    flex-direction: column;
    width: 444px;
  `,
  LeftCompanyName: styled.div`
    font-weight: bold;
    font-size: 32px;
    line-height: 60px;
    color: #FFFFFF;
    display: flex;
  `,
  LeftCompanySubName: styled.div`
    font-weight: bold;
    font-size: 48px;
    line-height: 60px;
    color: #FFFFFF;
    display: flex;
  `,
  LeftLine: styled.div`
    background: #A6A6A6;
    width: 150.5px;
    height: 6px;
    border-radius: 6px;
    border: none;
    margin-left: 0;
    margin-top: 25px;
  `,
  LeftCompanyDescription: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
    color: #FFFFFF;
    display: flex;
    margin-top: 25px;
  `,
  LeftButton: styled(Button)`
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    min-width: 112px;
    margin-right: auto;
    margin-top: 32px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  `,
}
const TitleSection = (): JSX.Element => {
  return (
    <STitleSection.Container>
      <STitleSection.LeftContainer>
        <STitleSection.LeftWrapper>
          <STitleSection.LeftCompanyName>
            eCloudture
          </STitleSection.LeftCompanyName>
          <STitleSection.LeftCompanySubName>
            elearning platform
          </STitleSection.LeftCompanySubName>
          <STitleSection.LeftLine />
          <STitleSection.LeftCompanyDescription>
            <FormattedMessage id="M002" />
          </STitleSection.LeftCompanyDescription>
          <STitleSection.LeftButton as={Link} to={'/register'}>
            <FormattedMessage id="M003" />
          </STitleSection.LeftButton>
        </STitleSection.LeftWrapper>
      </STitleSection.LeftContainer>
    </STitleSection.Container>
  )
}

const SLabSection = {
  Container: styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${LabSectionBackground});
    overflow: auto;
  `,
  ContentContainer: styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1169px;
    align-items: center;
  `,
  DemoVideo: styled(ReactPlayer)`
    border-radius: 20px;
    overflow: hidden;
  `,
  LabImage: styled.img`
    width: 118.2px;
    height: 91.55px;
  `,
  RightContainer: styled.div`
    max-width: 620px;
    display: flex;
    flex-direction: column;
    margin-top: 37px;
    margin-left: 67px;
    margin-bottom: 41px;
  `,
  RightTitle: styled.div`
    font-weight: bold;
    font-size: 36px;
    line-height: 52px;
    color: #313131;
    margin-top: 15px;
    &::before {
      content: url(${TitleIcon});
      margin-right: 11px;
    }
  `,
  RightDescription: styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 34px;
    color: #666666;
    margin-top: 32px;
    text-align: justify;
  `,
}
const LabSection = (): JSX.Element => {
  return (
    <SLabSection.Container>
      <SLabSection.ContentContainer>
        <SLabSection.DemoVideo
          url={'https://www.youtube.com/watch?v=XuIww8VvOEw'}
          playing={true}
          muted={true}
          width={571}
          height={327.72}
        />
        <SLabSection.RightContainer>
          <SLabSection.LabImage src={LabImage} />
          <SLabSection.RightTitle>
            Hands-on Lab
          </SLabSection.RightTitle>
          <SLabSection.RightDescription>
            <FormattedMessage id="M005" values={{ br: <br/> }} />
          </SLabSection.RightDescription>
        </SLabSection.RightContainer>
      </SLabSection.ContentContainer>
    </SLabSection.Container>
  )
}

const SMultiCloudSection = {
  Container: styled.div`
    height: 100%;
    display: flex;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${MultiCloudSectionBackground});
    overflow: auto;
  `,
  LeftContainer: styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  LeftWrapper: styled.div<{ lang: string }>`
    display: flex;
    flex-direction: column;

    ${props => {
      switch (props.lang) {
      case 'en':
        return { maxWidth: '410px' }
      case 'zh':
      default:
        return { maxWidth: '378px' }
    }
    }};
  `,
  LeftTitle: styled.div`
    font-weight: bold;
    font-size: 36px;
    line-height: 52px;
    color: #FFFFFF;

    &::before {
      content: url(${TitleIcon});
      margin-right: 11px;
    }
  `,
  LeftDescription: styled.div`
    font-weight: 500;
    font-size: 18px;
    line-height: 34px;
    color: #FFFFFF;
    margin-top: 32px;
    text-align: justify;
  `,
  RightForegroundContainer: styled.div`
    height: 100%;
    position: relative;
  `,
  RightForegroundLineArt: styled.img.attrs({ src: MultiCloudSectionLineArt, alt: 'multi-cloud-line-art'})`
    height: 100%;
    mix-blend-mode: overlay;
  `,
  RightForegroundIcon: styled.img.attrs({ src: MultiCloudSectionIcon, alt: 'multi-cloud-icon'})`
    height: 50%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  `

}
const MultiCloudSection = (): JSX.Element => {
  const languageContext = useContext(LanguageContext);

  return (
    <SMultiCloudSection.Container>
      <SMultiCloudSection.LeftContainer>
        <SMultiCloudSection.LeftWrapper lang={languageContext.lang}>
          <SMultiCloudSection.LeftTitle>
            <FormattedMessage id="M006" />
          </SMultiCloudSection.LeftTitle>
          <SMultiCloudSection.LeftDescription>
            <FormattedMessage id="M007" />
          </SMultiCloudSection.LeftDescription>
        </SMultiCloudSection.LeftWrapper>
      </SMultiCloudSection.LeftContainer>
      <SMultiCloudSection.RightForegroundContainer>
        <SMultiCloudSection.RightForegroundLineArt />
        <SMultiCloudSection.RightForegroundIcon />
      </SMultiCloudSection.RightForegroundContainer>
    </SMultiCloudSection.Container>
  )
}

const SDomainSection = {
  Container: styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${DomainSectionBackground});
    overflow: auto;
  `,
  ContentContainer: styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1169px;
    align-items: center;
  `,
  DomainsImage: styled.img``,
  RightContainer: styled.div`
    max-width: 620px;
    display: flex;
    flex-direction: column;
    margin-top: 37px;
    margin-left: 67px;
    margin-bottom: 41px;
  `,
  RightTitle: styled.div`
    font-weight: bold;
    font-size: 36px;
    line-height: 52px;
    color: #313131;

    &::before {
      content: url(${TitleIcon});
      margin-right: 11px;
    }
  `,
  RightDescription: styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 34px;
    color: #666666;
    margin-top: 32px;
    text-align: justify;
  `,
}
const DomainSection = (): JSX.Element => {
  const intl = useIntl();
  return (
    <SDomainSection.Container>
      <SDomainSection.ContentContainer>
        <SDomainSection.DomainsImage src={intl.locale === 'en' ? EnglishDomainsImage : ChineseDomainsImage} />
        <SDomainSection.RightContainer>
          <SDomainSection.RightTitle>
            <FormattedMessage id="M008" />
          </SDomainSection.RightTitle>
          <SDomainSection.RightDescription>
            <FormattedMessage id="M009" />
          </SDomainSection.RightDescription>
        </SDomainSection.RightContainer>
      </SDomainSection.ContentContainer>
    </SDomainSection.Container>
  )
}

const SMultiLanguageSection = {
  Container: styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${MultiLanguageSectionBackground});
    overflow: auto;
  `,
  LeftContainer: styled.div`
    max-width: 65%;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.8);
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  `,
  LeftWordContainer: styled.div`
    max-width: 659px;
    display: flex;
    flex-direction: column;
    margin-top: 37px;
    margin-left: 67px;
    margin-bottom: 41px;
  `,
  LeftTitleDescription: styled.div`
    font-weight: bold;
    font-size: 36px;
    line-height: 52px;
    color: #FFFFFF;

    &::before {
      content: url(${TitleIcon});
      margin-right: 11px;
    }
  `,
  LeftDescription: styled.div`
    margin-top: 32px;
    font-size: 18px;
    font-weight: 500;
    line-height: 34px;
    word-wrap: break-word;
    text-align: justify;
  `,
}
const MultiLanguageSection = (): JSX.Element => {
  return (
    <SMultiLanguageSection.Container>
      <SMultiLanguageSection.LeftContainer>
        <SMultiLanguageSection.LeftWordContainer>
          <SMultiLanguageSection.LeftTitleDescription>
            <FormattedMessage id="M017" />
          </SMultiLanguageSection.LeftTitleDescription>
          <SMultiLanguageSection.LeftDescription>
            <FormattedMessage id="M018" values={{ br: <br/> }} />
          </SMultiLanguageSection.LeftDescription>
        </SMultiLanguageSection.LeftWordContainer>
      </SMultiLanguageSection.LeftContainer>
    </SMultiLanguageSection.Container>
  )
}

const SLastSection = {
  Container: styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    flex-direction: column;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${LastSectionBackground});
    overflow: auto;
  `,
  GlobeImage: styled.img``,
  Description: styled.div`
    font-weight: bold;
    font-size: 36px;
    line-height: 52px;
    color: #434343;
    margin-top: 34px;
  `,
  Button: styled(Button)`
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    margin-top: 40px;
    min-width: 112px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  `,
}

const LastSection = (): JSX.Element => {
  return (
    <SLastSection.Container>
      <SLastSection.GlobeImage src={GlobeImg} />
      <SLastSection.Description>
        <FormattedMessage id="M024" />
      </SLastSection.Description>
      <SLastSection.Button as={Link} to={'/register'}>
        <FormattedMessage id="M025" />
      </SLastSection.Button>
    </SLastSection.Container>
  )
}

const SFooterSection = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: auto;
    background: #313131;
    width: 100%;
    padding-top: 69px;
  `,
  Logo: styled.img``,
  SupportEmail: styled.a`
    margin-top: 18px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #DEDEDE;
  `,
  MenuWrapper: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
    color: #EFEFEF;
    margin-top: 55px;
    width: 256px;
    justify-content: space-between;
  `,
  MenuItem: styled.div`
  `,
  Copyright: styled.div`
    margin-top: 45px;
    font-weight: bold;
    font-size: 12px;
    line-height: 17px;
    color: #A6A6A6;
    margin-bottom: 47px;
  `,

}
const FooterSection = (): JSX.Element => {
  const year = new Date().getFullYear();
  return (
    <SFooterSection.Container>
      <SFooterSection.Logo src={LogoIcon} />
      <SFooterSection.SupportEmail href="mailto:training@ecloudvalley.com">
        <FormattedMessage id="M026" />: training@ecloudvalley.com
      </SFooterSection.SupportEmail>
      <SFooterSection.MenuWrapper>

        <SFooterSection.MenuItem as={Link} to={'/terms'}>
          <FormattedMessage id="M027" />
        </SFooterSection.MenuItem>

        <SFooterSection.MenuItem as={Link} to={'/privacy'}>
          <FormattedMessage id="M028" />
        </SFooterSection.MenuItem>

        <SFooterSection.MenuItem as={Link} to={'/faq'}>
          <FormattedMessage id="M029" />
        </SFooterSection.MenuItem>

      </SFooterSection.MenuWrapper>
      <SFooterSection.Copyright>
        Copyright {year} © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
      </SFooterSection.Copyright>
    </SFooterSection.Container>
  )
}

const LandingPage = (props: RouteProps): JSX.Element => {
  useEffect(() => {
    const params = new URLSearchParams(props.location?.search);
    const invitation = params.get('invitation');
    if (invitation) {
      localStorage.setItem('invitation', invitation);
    }
  }, [props.location?.search]);

  return (
    <>
      <Header />
      <TitleSection />
      <LabSection />
      <MultiCloudSection />
      <DomainSection />
      <MultiLanguageSection />
      <LastSection />
      <FooterSection />
    </>
  )
}

export { LandingPage as default };
